import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col } from "antd";
import { InboxCasesTable } from "templates";
import { StageTabsGenerator } from "hocs";
import {
    fetchCases,
    fetchStageCase,
    fetchBucketCases,
    bulkAssignBucketCases,
    downloadCasesXlsx
} from "store/actions";

const StageTabs = StageTabsGenerator(InboxCasesTable);

class InboxView extends React.Component {
    render() {
        const {
            fetchStageCase,
            fetchBucketCases,
            cases,
            stagesStatus,
            stages,
            user,
            bulkAssignBucketCases,
            loading
        } = this.props;
        return (
            <Row className={"p-5 h-100"}>
                <Col span={24} className={"h-100"}>
                    <StageTabs
                        loading={loading}
                        stages={stages}
                        defaultTab={stages.getDefaultTab()}
                        caseStatus={"INBOX"}
                        toggleHelp={this.props.toggleHelp}
                        participatedStages={this.props.participatedStages}
                        stagesStatus={stagesStatus}
                        history={this.props.history}
                        WrappedComponentProps={{
                            user: user.get("data"),
                            permissions: user.get("permissions"),
                            location: this.props.location,
                            cases,
                            stagesStatus,
                            fetchStageCase,
                            fetchBucketCases,
                            bulkAssignBucketCases,
                            size: "small",
                            handleSave: () => null,
                            editable: true,
                            onXlsxDownload: this.props.downloadCasesXlsx
                        }}
                    />
                </Col>
            </Row>
        );
    }
}

InboxView.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    user: PropTypes.object,

    stages: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    loading: PropTypes.bool,

    cases: PropTypes.object,
    stagesStatus: PropTypes.string,

    fetchStageCase: PropTypes.func,
    fetchBucketCases: PropTypes.func,

    participatedStages: PropTypes.object,
    toggleHelp: PropTypes.bool,
    bulkAssignBucketCases: PropTypes.func,
    downloadCasesXlsx: PropTypes.func
};

const mapStateToProps = state => ({
    cases: state.cases,
    loading: !state.stagePermissions.isDataFetched(),
    stages: state.stagePermissions,
    participatedStages: state.stages.get("data"),
    stagesStatus: state.stages.get("status"),
    user: state.user,
    toggleHelp: state.toggleHelp.get("value")
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCases,
            fetchStageCase,
            fetchBucketCases,
            bulkAssignBucketCases,
            downloadCasesXlsx
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InboxView);
